export enum EclVariableType {
  Text = 'Text',
  Number = 'Number',
  Date = 'Date',
  Boolean = 'Boolean',
  Country = 'Country',
  Currency = 'Currency',
  Percentage = 'Percentage'
}
